export const parseOfficeNumber = (officeNumber: string) => {
  return officeNumber.replace(/\d{4}(?=.)/g, '$&-')
}
